module.exports = __webpack_public_path__ + "img/submit-button.766c54cf.png";